import React, { useCallback } from 'react';
import { useRepresentativeImagesRedirectPath } from '../queries/useRepresentativeImagesRedirectPath';
import { isNil } from 'shared/src/utils';
import { Flex, RemoteImage } from '@banhala/ui-kit';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useOpenDeeplink } from 'shared/src/hooks';

export const AiStudioRedirect: React.FC = () => {
  const { data } = useRepresentativeImagesRedirectPath();
  const goodsSno = useGoodsSno();
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { openDeeplink } = useOpenDeeplink();

  const onPress = useCallback(() => {
    if (isNil(data)) return;

    if (isNil(data.deeplink)) return;
    openDeeplink(data.deeplink);
    logGoodsAnalytics({
      name: 'CLICK_AI_FITTING',
      analytics: {
        GOODS_SNO: goodsSno.toString(),
      },
    });
  }, [data, goodsSno, logGoodsAnalytics, openDeeplink]);

  if (isNil(data)) return null;

  if (isNil(data.resource_image)) return null;

  return (
    <Flex onPress={onPress}>
      <RemoteImage
        uri={data.resource_image.image_url}
        height={data.resource_image.height}
        width={data.resource_image.width}
      />
    </Flex>
  );
};
